import React, { createRef, useEffect, useState, useLayoutEffect } from "react";
import { useLocation, useRoutes, useNavigate } from "react-router-dom";
import routes from "./router/router";
import { Container, Navbar, Image, Form, Button } from "react-bootstrap";
import Modal from "react-bootstrap/Modal";
import InputGroup from "react-bootstrap/InputGroup";
import TopNavbar from "./pages/components/Navbar/Navbar";
import logo from "./static/logo.png";
import { Toaster } from "react-hot-toast";
import "./App.css";
import AuthProvider from "./providers/AuthProvider";
import { ConfigProvider, theme } from "antd";
import enUS from "antd/lib/locale/en_US";
import zhCN from "antd/lib/locale/zh_CN";
import { useTranslation } from "react-i18next";
import { useTheme } from "./providers/CustomThemeProvider";
import {GoogleOAuthProvider} from "@react-oauth/google";
const { defaultAlgorithm, darkAlgorithm } = theme;

function App() {
	const clientId = "135508130938-1cff7nignia59idp4gamtkn44pho89s5.apps.googleusercontent.com";
	const location = useLocation();
	const headHideList = [
		"/",
		"/login",
		"/login-by-phone",
		"/signup",
		"/welcome",
		"/app-head",
		"/docta-ai",
		"/docta-ai-image",
		"/docta-ai-streaming",
		"/demo",
		"/demo-multi",
		"/oauth2/redirect",
		"/oauth2/wechatredirect",
		"/d5data",
		"/docs",
		"/verify",
		"/forget-password",
	]; // 需要隐藏头部导航的路由页面
	const showNav = headHideList.includes(location.pathname);

	// 用于存储页面使用那种主题导航
	const themeList = [
		{ url: "/", class: "head-dark-theme" },
		{ url: "/safety", class: "Safety" },
		{ url: "/blog", class: "Blog" },
		{ url: "/about", class: "About" },
		{ url: "/product", class: "head-dark-theme" },
		{ url: "/privacy-policy", class: "head-light-theme" },
		{ url: "/Article", class: "Article" },
	];

	// 头部导航主题样式
	// const [themeClass, setThemeClass] = useState("head-dark-theme");
	useEffect(() => {
		// 查找有没有对应的头部导航主题，没有默认黑色主题
		const css = themeList.find((item) => item.url === location.pathname);
		if (css) {
			// setThemeClass(css.class);
		}
	});

	// 路由组件
	const routeElement = useRoutes(routes.routes);
	// 导航Ref
	const nav = createRef<HTMLDivElement>();
	// 根据当前滚动条的位置判断导航条的主题色，此处为导航条的位置state
	const [scrollPosition, setScrollPosition] = React.useState(0);
	// 导航主题样式变量
	let navClass;
	if (scrollPosition > 20) {
		navClass = "bg-black-nav";
	} else {
		navClass = "bg-transparent-nav";
	}

	const navigate = useNavigate();
	const { isDarkMode, switchTheme } = useTheme();

	useLayoutEffect(() => {
		window.scrollTo({ top: 0 });
	}, [navigate]);

	// const handleScroll = () => {
	// 	// 处理滚动事件的逻辑
	// 	setScrollPosition(window.pageYOffset || document.documentElement.scrollTop);
	// };
	// useEffect(() => {
	// 	window.addEventListener("scroll", handleScroll);
	// 	return () => {
	// 		window.removeEventListener("scroll", handleScroll);
	// 	};
	// }, []);

	const { t, i18n } = useTranslation();
	const [language, setLanguage] = useState(i18n.language);

	useEffect(() => {
		setLanguage(i18n.language);
	}, [i18n.language]);

	useEffect(() => {
		if (process.env.REACT_APP_ENV?.endsWith("en")) {
			i18n.changeLanguage("en");
		} else {
			console.log(
				process.env.REACT_APP_ENV,
				process.env.REACT_APP_ENV?.endsWith("en")
			);
			i18n.changeLanguage("zh");
		}
	}, [process.env.REACT_APP_ENV]);

	return (
		<>
			<GoogleOAuthProvider clientId={clientId}>
				<ConfigProvider
					locale={language === "en" ? enUS : zhCN}
					theme={{
						algorithm: isDarkMode ? darkAlgorithm : defaultAlgorithm,
						token: {
							colorPrimary: "#a5affb",
						},
					}}
				>
					<AuthProvider>
						<Toaster />
						<></>
						{/* {showNav ? (
						<></>
					) : (
						<TopNavbar navClass={navClass} themeClass={themeClass} />
					)} */}

						<div>{routeElement}</div>
					</AuthProvider>
				</ConfigProvider>
			</GoogleOAuthProvider>

		</>
	);
}

export default App;
